import { render, staticRenderFns } from "./FacultyModal.vue?vue&type=template&id=04098e54"
import script from "./FacultyModal.vue?vue&type=script&lang=js"
export * from "./FacultyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports